import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { CostBreakdownItem } from '@/types/reports';
import { useCompanyLocale } from '@/hooks/useCompanyLocale';

interface CostBreakdownProps {
  items: CostBreakdownItem[];
}

export const CostBreakdown = ({ items }: CostBreakdownProps) => {
  const { formatMoney } = useCompanyLocale();
  const formatCurrency = (amount: number, isNegative?: boolean) => {
    const formatted = formatMoney(Math.abs(amount));

    return isNegative ? `-${formatted}` : formatted;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Cost Breakdown</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableBody>
            {items.map((item, index) => (
              <TableRow key={index} className="border-b last:border-0">
                <TableCell className={item.isBold ? 'font-bold' : ''}>
                  {item.label}
                </TableCell>
                <TableCell className={`text-right ${item.isBold ? 'font-bold' : ''} ${item.isNegative ? 'text-destructive' : ''}`}>
                  {formatCurrency(item.amount, item.isNegative)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
